import { useEffect, useState } from 'react';

import Loading from '../info/Loading';
import { getCertificateFormStructure } from './api';
import DynamicFormBase, { DynamicFormBaseProps } from './DynamicFormBase';

interface DynamicFormProps extends Omit<DynamicFormBaseProps, 'structure'> {
  certificateTypeCode: string;
  studyPlanEnrollmentId?: number;
}

function DynamicForm(props: DynamicFormProps) {
  const [structure, setStructure] = useState<any>(null);
  const [options, setOptions] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchFormularioConfig() {
      if (!props.certificateTypeCode) return;

      try {
        setIsLoading(true);
        const formStructure = await getCertificateFormStructure(
          props.certificateTypeCode,
          props.studyPlanEnrollmentId,
        );
        setStructure(formStructure.data.structure);
        setOptions(formStructure.data.options || {});
      } catch (error) {
        setStructure([]);
        setOptions({});
      } finally {
        setIsLoading(false);
      }
    }
    fetchFormularioConfig();
  }, [props.certificateTypeCode, props.studyPlanEnrollmentId]);

  if (isLoading || structure === null) {
    return <Loading insideCard textBody={'Cargando formulario'} />;
  }

  return <DynamicFormBase {...props} structure={structure} options={options} />;
}

export default DynamicForm;
